// Keep venue-admin sessions signed in across PWA relaunches.
//
// The venue-admin session (per-venue PIN tokens `venueAdminToken_<slug>`,
// `venueAdminAuth_<slug>`, `venueAdminRole_<slug>`, etc.) was stored in
// sessionStorage, which the OS wipes whenever a home-screen (standalone) PWA is
// torn down — e.g. when the Android Back button exits the app. That forced a
// re-login on every reopen.
//
// This shim transparently routes any `venueAdmin*` key to localStorage so the
// session persists, without touching the ~40 existing call sites. Only these
// keys are affected; all other sessionStorage usage is untouched.
export function installVenuePersistence() {
  if (typeof window === "undefined" || !window.sessionStorage || !window.localStorage) return;
  const PREFIX = "venueAdmin";
  const ss = window.sessionStorage;
  const ls = window.localStorage;

  // One-time migration of any session entries left over from a previous version.
  try {
    const stale = [];
    for (let i = 0; i < ss.length; i++) {
      const k = ss.key(i);
      if (k && k.startsWith(PREFIX)) stale.push(k);
    }
    stale.forEach((k) => {
      if (ls.getItem(k) === null) ls.setItem(k, ss.getItem(k));
      Storage.prototype.removeItem.call(ss, k);
    });
  } catch (_) { /* storage disabled */ }

  const origSet = Storage.prototype.setItem;
  const origGet = Storage.prototype.getItem;
  const origRemove = Storage.prototype.removeItem;

  ss.setItem = (k, v) => (typeof k === "string" && k.startsWith(PREFIX))
    ? origSet.call(ls, k, v) : origSet.call(ss, k, v);
  ss.getItem = (k) => (typeof k === "string" && k.startsWith(PREFIX))
    ? origGet.call(ls, k) : origGet.call(ss, k);
  ss.removeItem = (k) => (typeof k === "string" && k.startsWith(PREFIX))
    ? origRemove.call(ls, k) : origRemove.call(ss, k);
}
